/* /bat-comparator-json is proxied to either chrome data or jato. See LSDS */
define('lib/services/compare-service-chrome',['lib/rest'], function (RestAPI) {
  var spec = {
    host: '/bat-comparator-json',
    apis: {
      report: {
        url: '/comparisonReport',
        calls: {
          fetch: {
            url: '',
            dataType: 'json',
            defaults: {
              clientId: 'Toyota',
              langCode: 1, // English
              vehicles: null // Chrome Ids
            }
          }
        }
      }
    }
  };

  return new RestAPI(spec);
});

